import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StatusPill } from '@/components/app/misc';
/** Status do contratante (config utils.tenant_status), mesmas cores da lista antiga. */
const TENANT_STATUS = {
    active: { label: 'Ativo', tone: 'success' },
    inactive: { label: 'Inativo', tone: 'danger' },
    overdue: { label: 'Suspenso', tone: 'warning' },
};
export function TenantStatus({ status }) {
    const item = (status && TENANT_STATUS[status]) || { label: 'Bloqueado', tone: 'neutral' };
    return _jsx(StatusPill, { tone: item.tone, children: item.label });
}
/** Etiqueta pequena (beta, trial), no tom da marca. */
export function SoftTag({ children }) {
    return _jsx("span", { className: "inline-flex h-5 items-center rounded-full bg-primary/10 px-2 text-[11px] font-medium text-primary", children: children });
}
/** Máscara 000.000.000-00 (jquery.mask da tela antiga). */
export function maskCpf(value) {
    const d = value.replace(/\D/g, '').slice(0, 11);
    let out = d.slice(0, 3);
    if (d.length > 3)
        out += '.' + d.slice(3, 6);
    if (d.length > 6)
        out += '.' + d.slice(6, 9);
    if (d.length > 9)
        out += '-' + d.slice(9, 11);
    return out;
}
/** Máscara (00) 0 0000-0000 (jquery.mask da tela antiga). */
export function maskPhone(value) {
    const d = value.replace(/\D/g, '').slice(0, 11);
    if (!d)
        return '';
    let out = '(' + d.slice(0, 2);
    if (d.length > 2)
        out += ') ' + d.slice(2, 3);
    if (d.length > 3)
        out += ' ' + d.slice(3, 7);
    if (d.length > 7)
        out += '-' + d.slice(7, 11);
    return out;
}
/** maskMoney da tela antiga: decimal ".", sem milhar, zero permitido, até 10 caracteres. */
export function maskDecimal(value) {
    const digits = value.replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, 9);
    if (!digits)
        return '0.00';
    return (parseInt(digits, 10) / 100).toFixed(2);
}
/** Bloco com título, no padrão das tabelas do painel. */
export function Section({ id, title, description, actions, children }) {
    return (_jsxs("section", { id: id, className: "flex scroll-mt-20 flex-col gap-3", children: [_jsxs("div", { className: "flex flex-wrap items-end justify-between gap-2", children: [_jsxs("div", { children: [_jsx("h2", { className: "text-base font-semibold", children: title }), description ? _jsx("p", { className: "text-[13px] text-muted-foreground", children: description }) : null] }), actions] }), children] }));
}
